module.exports = __webpack_public_path__ + "static/media/py.5f9ca06c.jpg";